import { Value } from 'slate';
import { SET_COVER_LETTER_INITIAL_STATE } from '../actions/actionTypes/editCoverLetterForm';
import coverLetterDefaultValues from '../constants/coverLetterDefaultValues';
import getField from './versions/getField';
import getUserPreferences from './versions/getUserPreferences';

export const getEditCoverLetterData = (data, formatType, universityPlan) => {
  const DEFAULT = coverLetterDefaultValues({ universityPlan });
  let parsedData = {
    userId: data.userId || DEFAULT.userId,
    removeOnNextLoad: data.removeOnNextLoad || { comments: [] },
    eventTypes: [],
    templateType: data.templateType || DEFAULT.templateType,
    permissions: data.permissions || DEFAULT.permissions,
    documentName: data.documentName || DEFAULT.documentName,
    status: data.status || DEFAULT.status,
    name: data.name || DEFAULT.name,
    coverLetterType: data.coverLetterType || DEFAULT.coverLetterType,
    userPreferences: data.userPreferences
      ? JSON.parse(data.userPreferences)
      : DEFAULT.userPreferences,
    documentPicture: data.documentPicture || null,
    editedInputs: DEFAULT.editedInputs,
    senderName:
      (data.senderName && Value.fromJSON(JSON.parse(data.senderName))) ||
      Value.fromJSON(DEFAULT.senderName),
    senderPhoneNumber:
      (data.senderPhoneNumber &&
        Value.fromJSON(JSON.parse(data.senderPhoneNumber))) ||
      Value.fromJSON(DEFAULT.senderPhoneNumber),
    senderTagline:
      (data.senderTagline && Value.fromJSON(JSON.parse(data.senderTagline))) ||
      Value.fromJSON(DEFAULT.senderTagline),
    senderAddress:
      (data.senderAddress && Value.fromJSON(JSON.parse(data.senderAddress))) ||
      Value.fromJSON(DEFAULT.senderAddress),
    senderEmail:
      (data.senderEmail && Value.fromJSON(JSON.parse(data.senderEmail))) ||
      Value.fromJSON(DEFAULT.senderEmail),
    personalLinks:
      (data.personalLinks && Value.fromJSON(JSON.parse(data.personalLinks))) ||
      Value.fromJSON(DEFAULT.personalLinks),
    receiverName:
      (data.receiverName && Value.fromJSON(JSON.parse(data.receiverName))) ||
      Value.fromJSON(DEFAULT.receiverName),
    receiverTagline:
      (data.receiverTagline &&
        Value.fromJSON(JSON.parse(data.receiverTagline))) ||
      Value.fromJSON(DEFAULT.receiverTagline),
    receiverOrganization:
      (data.receiverOrganization &&
        Value.fromJSON(JSON.parse(data.receiverOrganization))) ||
      Value.fromJSON(DEFAULT.receiverOrganization),
    receiverAddress:
      (data.receiverAddress &&
        Value.fromJSON(JSON.parse(data.receiverAddress))) ||
      Value.fromJSON(DEFAULT.receiverAddress),
    letterDate:
      (data.letterDate && Value.fromJSON(JSON.parse(data.letterDate))) ||
      Value.fromJSON(DEFAULT.letterDate),
    subjectLine:
      (data.subjectLine && Value.fromJSON(JSON.parse(data.subjectLine))) ||
      Value.fromJSON(DEFAULT.subjectLine),
    openGreeting:
      (data.openGreeting && Value.fromJSON(JSON.parse(data.openGreeting))) ||
      Value.fromJSON(DEFAULT.openGreeting),
    closeGreeting:
      (data.closeGreeting && Value.fromJSON(JSON.parse(data.closeGreeting))) ||
      Value.fromJSON(DEFAULT.closeGreeting),
  };

  /**
   * letterBody
   */
  let letterBodyData = getField({
    fieldData: data.letterBody,
    fieldType: 'letterBody',
    nodeType: 'letter_body',
    userPreferences: parsedData.userPreferences,
    defaultVal: DEFAULT,
  });

  letterBodyData = {
    ...letterBodyData,
    letterBody: Value.fromJSON(letterBodyData.letterBody),
  };

  parsedData = {
    ...parsedData,
    ...letterBodyData,
  };

  parsedData = {
    ...parsedData,
    userPreferences: getUserPreferences(parsedData.userPreferences),
  };

  /**
   * UserPreferences
   */

  let userPreferencesData = getField({
    fieldType: 'userPreferences',
    formatType,
    userPreferences: parsedData.userPreferences,
  });
  userPreferencesData = {
    ...userPreferencesData,
  };
  parsedData = {
    ...parsedData,
    ...userPreferencesData,
  };

  return parsedData;
};

export default (params) => {
  const { documentData, formatType, documentId, universityPlan } = params;
  const editCoverLetterInitialState = getEditCoverLetterData(
    documentData,
    formatType,
    universityPlan,
  );

  /**
   * TODO: Write logic for personal info separate condition afte completing the section
   */

  return {
    ...editCoverLetterInitialState,
    eventType: SET_COVER_LETTER_INITIAL_STATE,
    formatType,
    documentId,
    blobURLs: {},
    saveStatus: true,
    history: {
      tail: {
        data: {},
        next: null,
        prev: null,
        index: 0,
        changeData: [],
      },
    },
    counter: {},
    isFailed: null,
  };
};
